import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/imgs/about-1.png")